import { isObject } from '@/helpers/common';

export const areArraysEqual = (a, b) =>
  a.length === b.length &&
  a.every((aVal, i) => {
    const aValue = isObject(aVal) ? aVal._filter : aVal;
    const bValue = isObject(b[i]) ? b[i]._filter : b[i];

    return aValue === bValue;
  });

export const getItemValueAsScalar = (item) => (isObject(item.value) ? item.value._filter : item.value);
